import React, { useState, useImperativeHandle } from 'react';
import { useFormik, FormikProvider, FieldArray } from 'formik';
import moment from 'moment';

// components
import FormSectionHeader from '../../../../../components/forms/FormSectionHeader/FormSectionHeader.component';
import FormDataPoint from '../../../../../components/forms/FormDataPoint/FormDataPoint.component';
import CrewAssignment from '../../../../../components/forms/lists/CrewAssignment/CrewAssignment.component';
import InputField from '../../../../../components/forms/InputField/InputField.component';

const CREW_MEMBER_CLASS_CHOICES = {
    J: 'Journeyman',
    Y: 'Yard',
    A_1: 'A1',
    A_2: 'A2',
    A_3: 'A3',
    A_4: 'A4',
    A_5: 'A5',
    A_6: 'A6',
    A_7: 'A7',
    A_8: 'A8',
    F: 'Foreman',
    S: 'Superintendent'
}

const MarkAsPaidForm = React.forwardRef(({ prefillData = null, errors}, ref) => {

    useImperativeHandle(ref, () => ({
        getData: () => { return formik.values }
    }))

    const formik = useFormik({
        initialValues: prefillData ? {...prefillData, paidDate: moment()} : {
            paidDate: moment()
        }
    })

    return (
        <FormikProvider value={formik}>
            <form onSubmit={formik.handleSubmit}>
                <FormDataPoint label='Job' value={prefillData['jobDay'] ? prefillData['jobDay'].job.name : ""} />
                <FormDataPoint label='Scope' value={prefillData['jobDay'].scope} />

                <InputField 
                    id={"paidDate"}
                    type="date"
                    placeholder="Paid Date"
                    onChange={(value) => formik.setFieldValue("paidDate", value)}
                    value={formik.values.paidDate}
                    isValid={errors['paidDate']}
                />

                <FormSectionHeader text='Crew Assignments' />

                {
                    prefillData.assignments && prefillData.assignments.map((assignment, index) => {
                        return (<CrewAssignment
                            key={index}
                            variant='mark-as-paid'
                            data={{
                                title: `${assignment.crewMember.firstName} ${assignment.crewMember.lastName}`,
                                subTitle: `${moment(`1/1/23 ${assignment.startTime}`).format("hh:mm A")} - ${moment(`1/1/23 ${assignment.endTime}`).format("hh:mm A")}`,
                                isGood: assignment.finalApproval,
                                rightLabelGood: "Approved",
                                rightLabelBad: "Not Approved"
                            }}
                        />)
                    })
                }
            </form>
        </FormikProvider>
    )
})

export default MarkAsPaidForm